import { render, staticRenderFns } from "./story_publication.vue?vue&type=template&id=349370f0&scoped=true&lang=pug"
import script from "./story_publication.vue?vue&type=script&lang=js"
export * from "./story_publication.vue?vue&type=script&lang=js"
import style0 from "./story_publication.vue?vue&type=style&index=0&id=349370f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349370f0",
  null
  
)

export default component.exports